


























































































































































































import Vue from 'vue'
import moment from 'moment'
import { CompanyEmployee } from '@/model/company/CompanyEmployee'
import { Department } from '@/model/companyStructure/Department'
import { Employee } from '@/model/companyStructure/Employee'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import Password from './employee-form/Password.vue'
import Capacity from './employee-form/Capacity.vue'
import CostCenter from './employee-form/CostCenter.vue'
import Qcq from './employee-form/Qcq.vue'
import { CHANGE_EMPLOYEE_DATA, FETCH_EMPLOYEE_PHOTO } from '@/store/action-types'
import { EmployeeDataPayload } from '@/types/payload'
import UpdatePhotoDialog from '@/components/employee-form/UpdatePhotoDialog.vue'
import { School } from '@/model/companyStructure/School'
import EmployeeAdditionalFields from '@/components/additional-fields/EmployeeAdditionalFields.vue'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { UpdateEmployeeResponse } from '@/types/service-response'

interface ComponentData {
  rules: Array<Function>
  activeTab: number
  departmentSelectionList: Array<number>
  planningSelection: number
  showSuccessSnackbar: boolean
  showErrorSnackbar: boolean
  errorMessage: string
  showUpdatePhotoDialog: boolean
  photoData: string | undefined
  photoRemove: boolean
  photoUpdate: boolean
  employeePhoto: string | undefined
  schoolSelection: number | undefined
  isBusinessMailEdit: boolean
}

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface PlaningGroupItem {
  id: number
  name: string
}
interface SelectedDepartments {
  abteilungId: number
}

export default Vue.extend({
  name: 'EmployeeForm',

  components: {
    Password,
    Capacity,
    CostCenter,
    Qcq,
    UpdatePhotoDialog,
    EmployeeAdditionalFields
  },

  props: {
    employeeItem: {
      type: Object as () => CompanyEmployee
    },

    departmentList: {
      type: Array as () => Array<Department>
    },

    planningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },

    employeeList: {
      type: Array as () => Array<Employee>
    },

    employeePhotoUrl: {
      type: String
    },

    schoolList: {
      type: Array as () => Array<School>
    }
  },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || ''],
      activeTab: 0,
      departmentSelectionList: [],
      planningSelection: 0,
      showSuccessSnackbar: false,
      showErrorSnackbar: false,
      errorMessage: '',
      showUpdatePhotoDialog: false,
      photoData: undefined,
      photoRemove: false,
      photoUpdate: false,
      employeePhoto: undefined,
      schoolSelection: undefined,
      isBusinessMailEdit: false
    }
  },

  computed: {
    birthDate (): string | undefined {
      if (this.employeeItem.birthDate) {
        return moment(this.employeeItem.birthDate).format('DD.MM.YYYY')
      }

      return undefined
    },

    entryDate (): string | undefined {
      if (this.employeeItem.entryDate) {
        return moment(this.employeeItem.entryDate).format('DD.MM.YYYY')
      }

      return undefined
    },

    filteredDepartmentList (): Array<Department> {
      return this.departmentList.filter((item: Department) => item.id !== this.employeeItem.departmentId)
    },

    planningGroup (): Array<PlaningGroupItem> {
      const items: Array<PlaningGroupItem> = []

      let foundItem: Department | undefined = this.departmentList.find((i: Department) => this.employeeItem.departmentId === i.id)

      this.planningGroupList.forEach((i: PlanningGroup) => {
        if (foundItem && this.employeeItem.departmentId === i.department) {
          const name: string = foundItem.PCABTLabel + ' / ' + i.planningGroupName
          items.push({ id: i.id, name: name })
        }
      })

      return items
    },

    getEmployeeTitle (): string {
      if(this.employeeItem.shortName || this.employeeItem.givenName || this.employeeItem.familyName || this.employeeItem.personalNumber) {
        return `${this.employeeItem.shortName ? this.employeeItem.shortName : ''} / ${this.employeeItem.givenName ? this.employeeItem.givenName : ''} ${this.employeeItem.familyName ? this.employeeItem.familyName : ''} (${this.employeeItem.personalNumber ? this.employeeItem.personalNumber : ''})`
      } else {
        return ''
      }
    },

    showPasswordTab (): boolean {
      return securityService.isVisible(SecurityArea.Employee, SecurityComponent.Password)
    },

    isDisabledPasswordTab (): boolean {
      return securityService.isDisabled(SecurityArea.Employee, SecurityComponent.Password)
    },
  },

  watch: {
    employeeItem (newVal: CompanyEmployee): void {
      this.isBusinessMailEdit = false
      this.initDepartmentSelectionList()
      if (newVal) {
        this.activeTab = 0
      }
      this.initPlanningSelection()
      this.fetchPhoto()
      this.initSchoolSelection()
    }
  },

  methods: {
    onSaveButtonClick (): void {
      //@ts-ignore
      if(this.$refs['form'].validate()) {
        this.saveEmployeeData()
      }
    },

    setPlanningSelectionId (): number {
      let id = this.planningGroupList.find((item: PlanningGroup) => item.id === this.planningSelection)
      if (id) {
        return id.planningGroup
      } else {
        return 0
      }
    },

    async saveEmployeeData (): Promise<void> {
      if (this.employeeItem) {
        let selectedDepartments: Array<SelectedDepartments> = []
        this.departmentSelectionList.forEach((item: number) => {
          selectedDepartments.push({abteilungId: item})
        })
        let allDepartments: Array<SelectedDepartments> = []
        if(this.employeeItem.isFloater && this.departmentSelectionList.length === 0) {
          allDepartments = this.filteredDepartmentList.map((item: Department) => {
            return {abteilungId: item.id}
          })
        }
        let payload: EmployeeDataPayload = {
          id: this.employeeItem.id,
          isPlanable: this.employeeItem.isPlanable,
          isFloater: this.employeeItem.isFloater,
          position: this.employeeItem.position,
          planningGroupId: this.setPlanningSelectionId(),
          replacementOfEmployeeId: this.employeeItem.replacementOfEmployeeId || null,
          supervisorId: this.employeeItem.supervisorId || null,
          nickName: this.employeeItem.nickName || '',
          preferredLanguageId: this.employeeItem.preferredLanguageId,
          allDepartments: allDepartments,
          floaterDepartments: selectedDepartments,
          photoData: this.photoData,
          photoRemove: this.photoRemove,
          photoUpdate: this.photoUpdate,
          isApprentice: this.employeeItem.isApprentice,
          schoolIn: this.schoolSelection || null,
          SYZInTimeAktiv: this.employeeItem.SYZInTimeAktiv,
          shortName: this.employeeItem.shortName,
          businessEmail: this.employeeItem.businessEmail ?  this.employeeItem.businessEmail : ''
        }
        try {
          const response: UpdateEmployeeResponse = await this.$store.dispatch(CHANGE_EMPLOYEE_DATA, payload)
          if(response && !response.IsError) {
            this.$emit('refreshEmployee')
            this.isBusinessMailEdit = false
            this.showSuccessSnackbar = true
            this.photoData = undefined
            this.photoUpdate = false
            this.photoRemove = false
            this.fetchPhoto()
          } else {
            if(response && response.DuplicatedKurzzeichen) {
              this.errorMessage = this.$t('employeeFormComponent.duplicateAbbreviation').toString()
              this.showErrorSnackbar = true
            } else {
              this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
              this.showErrorSnackbar = true
            }
          }
        } catch (e) {
          this.errorMessage = this.$t('employeeFormComponent.changesCouldNotBeSaved').toString()
          this.showErrorSnackbar = true
        }
      }
    },

    onPhotoClick (): void {
      this.showUpdatePhotoDialog = true
    },

    onCloseUpdatePhotoDialogClick (): void {
      this.showUpdatePhotoDialog = false
    },

    onPhotoUpdateClick (): void {
      this.showUpdatePhotoDialog = false
      // @ts-ignore
      this.$refs.photoInput.click()
    },

    onPhotoRemoveClick (): void {
      this.showUpdatePhotoDialog = false
      this.photoRemove = true
      this.photoUpdate = true
    },

    onPhotoChange(e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target) {

              const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor
                const ctx = elem.getContext('2d')

                ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg')
                this.photoData = elem.toDataURL('image/jpeg')
                if(this.photoData) {
                  this.photoUpdate = true
                }
              }
            }
          }
        }
      }
    },

    onApprenticeChange(item: boolean): void {
      if(!item) {
        this.schoolSelection = undefined
      }
    },

    initDepartmentSelectionList (): void {
      if (this.employeeItem) {
        this.departmentSelectionList = this.employeeItem.floaterDepartments
        //this.departmentSelectionList = [this.employeeItem.departmentId]
      } else {
        this.departmentSelectionList = []
      }
    },

    initPlanningSelection (): void {
      if (this.employeeItem && this.employeeItem.planningGroupId && this.employeeItem.departmentId) {
        this.planningGroupList.forEach((item: PlanningGroup) => {
          if (item.planningGroup === this.employeeItem.planningGroupId && item.department === this.employeeItem.departmentId) {
            this.planningSelection = item.id
          }
        })
      } else {
        this.planningSelection = 0
      }
    },

    initSchoolSelection(): void {
      if (this.employeeItem && this.employeeItem.schoolIn) {
        this.schoolSelection = this.employeeItem.schoolIn
      } else {
        this.schoolSelection = undefined
      }
    },

    async fetchPhoto (): Promise<void> {
      try {
        this.employeePhoto = await this.$store.dispatch(FETCH_EMPLOYEE_PHOTO, this.employeeItem.id)
      } catch (e) {
        this.employeePhoto = undefined
      }
    }
  },

  mounted () {
    this.initDepartmentSelectionList()
    this.initPlanningSelection()
    this.fetchPhoto()
    this.initSchoolSelection()
  }
})
